export default __webpack_public_path__ + "static/media/plain-sticker-Y.14f692cc.png";